// extracted by mini-css-extract-plugin
module.exports = {"similarContainer":"CategoryContentSimilar_similarContainer__a1mBa"};